import {
  Campaign,
  Feed,
  Group,
  GroupWorkOutlined,
  Image,
  Message,
  RssFeed,
  TrendingUp,
  WorkOutline,
} from '@mui/icons-material';
import { Divider, Grid, List, Toolbar, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import SidebarLink from './SidebarLink';

const Sidebar = () => {
  const location = useLocation();

  return (
    <>
      <div>
        <Toolbar variant="dense" />
        <Divider />
        <List sx={{ p: 1 }}>
          <Grid
            container
            flexDirection="column"
            justifyContent="space-between"
            sx={{}}
          >
            <Grid item>
              <Typography variant="subtitle1" fontSize="12px" fontWeight="bold">
                COLLECTION TYPES
              </Typography>
              <SidebarLink
                to="/galleries"
                label="Gallery"
                active={location.pathname.startsWith('/galleries')}
                icon={<Image />}
              />
              <SidebarLink
                to="/news"
                label="News"
                active={location.pathname.startsWith('/news')}
                icon={<RssFeed />}
              />
              <SidebarLink
                to="/partners"
                label="Partner"
                active={location.pathname.startsWith('/partners')}
                icon={<GroupWorkOutlined />}
              />
              <SidebarLink
                to="/projects"
                label="Project"
                active={location.pathname.startsWith('/projects')}
                icon={<WorkOutline />}
              />
              <SidebarLink
                to="/publications"
                label="Publication"
                active={location.pathname.startsWith('/publications')}
                icon={<Feed />}
              />
              <SidebarLink
                to="/teams"
                label="Team"
                active={location.pathname.startsWith('/teams')}
                icon={<Group />}
              />
              <SidebarLink
                to="/testimonies"
                label="Testimony"
                active={location.pathname.startsWith('/testimonies')}
                icon={<Campaign />}
              />
            </Grid>

            <Grid item>
              <Typography
                variant="subtitle1"
                fontSize="12px"
                fontWeight="bold"
                sx={{ mt: 2 }}
              >
                SINGLE TYPES
              </Typography>
              <SidebarLink
                to="/stats"
                label="Stat"
                active={location.pathname.startsWith('/stats')}
                icon={<TrendingUp />}
              />
            </Grid>

            <Grid item>
              <Typography
                variant="subtitle1"
                fontSize="12px"
                fontWeight="bold"
                sx={{ mt: 2 }}
              >
                FORMS
              </Typography>

              <SidebarLink
                to="/contacts"
                label="Contact"
                active={location.pathname.startsWith('/contacts')}
                icon={<Message />}
              />
            </Grid>
          </Grid>
        </List>
      </div>
    </>
  );
};

export default Sidebar;
